export function formatTenantType(T, tenantType) {
  switch (tenantType) {
    case 'working professionals only': {
      return T('working professionals only');
    }
    case 'students only': {
      return T('students only');
    }
    default: {
      return T('students, working professionals');
    }
  }
}
